export default __webpack_public_path__ + "static/media/brand-logo.1ef7e880.gif";